var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.33333C0 0.596954 0.596954 0 1.33333 0H3.55556V8H1.33333C0.596954 8 0 7.40305 0 6.66667V1.33333ZM4.44444 0H6.66667C7.40305 0 8 0.596954 8 1.33333V3.55556H4.44444V0ZM8 4.44444H4.44444V8H6.66667C7.40305 8 8 7.40305 8 6.66667V4.44444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistIcon);
export default __webpack_public_path__ + "static/media/Playlist-icon.f0617ea0d35ec0e5e0a1079a06611f3d.svg";
export { ForwardRef as ReactComponent };